import { Button, Loader } from '@kanda-libs/ks-design-library';

import Container from './DownloadButton-container';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ isLoading }: ViewComponentProps) => (
  <Container>
    {({ onClick, isSubmitting }) => (
      <div className="flex flex-col">
        <Button.Text
          id="job-details-download-quote-as-pdf"
          label="Download quote as PDF"
          variant="outline"
          icon="download"
          left
          size={40}
          onClick={onClick}
          disabled={isLoading || isSubmitting}
          isLoading={isLoading || isSubmitting}
          className="mx-auto md:mx-0"
        />
        <Loader isLoading={isSubmitting} />
      </div>
    )}
  </Container>
);

ViewComponent.displayName = 'JobSidebar-DownloadButton-view';

ViewComponent.defaultProps = {
  isLoading: false,
};

export default ViewComponent;
